import { Controller } from 'react-hook-form';
import { TreeSelect } from 'primereact/treeselect';
import { twMerge } from 'tailwind-merge';

const BaseTreeSelect = (props) => {
    const {
        id,
        name,
        label,
        required = false,
        errors,
        className,
        placeholder,
        inputClassName,
        disabled = false,
        control,
        clearErrors,
        value,
        setValue,
        options,
        showClear,
        selectionMode = 'checkbox',
        metaKeySelection = false,
        display = 'chip',
        appendTo = 'self',
        template,
        filter = true,
        filterMode = 'lenient',
        onSelect,
        filterDelay
    } = props;

    const errorClassname = errors?.length ? 'border-theme1-error' : '';

    const valueTemplate =
        template ||
        ((selectedNodes) => {
            const count = Object.keys(selectedNodes || {}).length;
            return count > 0 ? `${count} selected` : (placeholder ?? 'Select');
        });

    return (
        <div className={twMerge('w-full', className)}>
            {control ? (
                <Controller
                    render={({ field }) => (
                        <TreeSelect
                            id={id ?? name}
                            name={name}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.value);
                                if (clearErrors) {
                                    clearErrors(name);
                                }
                                if (onSelect) {
                                    onSelect(e.value);
                                }
                            }}
                            valueTemplate={valueTemplate}
                            placeholder={placeholder ?? label}
                            required={required}
                            disabled={disabled}
                            className={twMerge(
                                'text-theme1-text1 rounded-2xl border border-theme1-text3 w-full outline-0 focus:outline-0 shadow-none text-base',
                                errorClassname,
                                inputClassName
                            )}
                            options={options}
                            selectionMode={selectionMode}
                            metaKeySelection={metaKeySelection}
                            display={display}
                            showClear={showClear}
                            appendTo={appendTo}
                            filter={filter}
                            filterMode={filterMode}
                            filterDelay={filterDelay}
                        />
                    )}
                    control={control}
                    name={name}
                />
            ) : (
                <TreeSelect
                    id={id ?? name}
                    name={name}
                    value={value}
                    onChange={(e) => {
                        if (setValue) {
                            setValue(e.value);
                        }
                        if (onSelect) {
                            onSelect(e.value);
                        }
                    }}
                    placeholder={placeholder ?? label}
                    required={required}
                    valueTemplate={valueTemplate}
                    disabled={disabled}
                    className={twMerge(
                        'text-theme1-text1 rounded-2xl border border-theme1-text3 w-full outline-0 focus:outline-0 shadow-none text-base',
                        errorClassname,
                        inputClassName
                    )}
                    options={options}
                    selectionMode={selectionMode}
                    metaKeySelection={metaKeySelection}
                    display={display}
                    showClear={showClear}
                    appendTo={appendTo}
                    filter={filter}
                    filterMode={filterMode}
                    filterDelay={filterDelay}
                />
            )}

            {errors &&
                errors.map((error) => (
                    <div key={error} className='mt-2.5 text-theme1-error'>
                        {error}
                    </div>
                ))}
        </div>
    );
};

export default BaseTreeSelect;
